export default __webpack_public_path__ + "static/media/spr-design-system-light.675b2ce3.png";